import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "../components/ui/accordion";
import { LegalLayout } from "../components/landing/LegalLayout";
import { useLang } from "../i18n/LanguageContext";

export default function Faq() {
  const { t } = useLang();
  return (
    <LegalLayout
      testId="page-faq"
      title={t.faqPage.title}
      subtitle={t.faqPage.subtitle}
    >
      <Accordion type="single" collapsible data-testid="faq-accordion">
        {t.faqPage.items.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="border-petrol/10"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="py-5 font-heading text-base font-bold text-petrol hover:no-underline sm:text-lg">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-base leading-relaxed text-petrol-soft">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </LegalLayout>
  );
}
